import ScrollMagic from 'scrollmagic'
import {TweenMax, TimelineMax} from 'gsap/TweenMax'
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'


let animate = $(window).width() > 768

//animate = false


if(animate) {


// init controller
   var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

   // build scenes
   new ScrollMagic.Scene({triggerElement: "#parallax1"})
       .setTween("#parallax1 > div", {y: "80%", ease: Linear.easeNone})
//        .addIndicators()
       .addTo(controller);

   // init controller
   var controller = new ScrollMagic.Controller();

   // build scenes
   new ScrollMagic.Scene({triggerElement: ".abtb-bloc-collection", duration: 400, offset: -100})
       .setClassToggle(".abtb-b2-dot", "anim1") // add class toggle
       //.addIndicators() // add indicators (requires plugin)
       .addTo(controller);

   new ScrollMagic.Scene({triggerElement: ".abtb-bloc-collection", duration: 400, offset: 100})
       .setClassToggle(".abtb-b2-dot", "anim2") // add class toggle
       //.addIndicators() // add indicators (requires plugin)
       .addTo(controller);


   new ScrollMagic.Scene({triggerElement: ".abtb-bloc-collection", duration: 2000, offset: 500})
       .setClassToggle(".abtb-b2-dot", "anim3") // add class toggle
       //.addIndicators() // add indicators (requires plugin)
       .addTo(controller);

   //**********************************************


   new ScrollMagic.Scene({triggerElement: ".b2", duration: 500, offset: 0})
       .setClassToggle(".b2", "anim1") // add class toggle
       //.addIndicators()
       .addTo(controller);

   new ScrollMagic.Scene({triggerElement: ".b2", duration: 700, offset: 500})
       .setClassToggle(".b2", "anim2") // add class toggle
       //.addIndicators()
       .addTo(controller);

   new ScrollMagic.Scene({triggerElement: ".b2 .bg-text", duration: 2000, offset: -300})
       .setClassToggle(".b2 .bg-text", "anim") // add class toggle
       //.addIndicators()
       .addTo(controller);

   new ScrollMagic.Scene({triggerElement: ".b3-1", duration: 2000, offset: 500})
       .setClassToggle(".b3-1 .bg-text", "anim") // add class toggle
      // .addIndicators()
       .addTo(controller);

new ScrollMagic.Scene({triggerElement: ".b3-1", duration: 2000, offset: -500})
    .setClassToggle(".b3-1 .img", "anim") // add class toggle
    // .addIndicators()
    .addTo(controller);

   new ScrollMagic.Scene({triggerElement: ".b3-2", duration: 2000, offset: -100})
       .setClassToggle(".b3-2 .bg", "anim") // add class toggle
       //.addIndicators()
       .addTo(controller);

   new ScrollMagic.Scene({triggerElement: ".b4", duration: 1000, offset: -100})
       .setClassToggle(".b4 .bg-text", "anim") // add class toggle
       //.addIndicators()
       .addTo(controller);

   new ScrollMagic.Scene({triggerElement: ".b5", duration: 2000, offset: -250})
       .setClassToggle(".b5 .bg-text", "anim") // add class toggle
       //.addIndicators()
       .addTo(controller);



} else {
   $('.anim').removeClass('.anim')
}


// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/5-raisons.js